import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './components/home/home.component';
import {AboutComponent} from './components/about/about.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonModule} from '@angular/material/button';
import {SortVisualizerComponent} from './components/sort-visualizer/sort-visualizer.component';
import {HeaderComponent} from './components/header/header.component';
import {MatSliderModule} from '@angular/material/slider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {ArtDisplayComponent} from './components/art-display/art-display.component';
import {MatTabsModule} from '@angular/material/tabs';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import { HueShifterComponent } from './components/hue-shifter/hue-shifter.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { HeaderV2Component } from './components/header-v2/header-v2.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    SortVisualizerComponent,
    HeaderComponent,
    ArtDisplayComponent,
    HueShifterComponent,
    HeaderV2Component,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatSliderModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        HttpClientModule,
        FormsModule,
        MatDividerModule,
        MatTooltipModule
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
